import { Dispatch, SetStateAction, useState } from 'react';
import {
  Flex,
  FlexBetween,
  FlexJustifyCenter,
  HubLengthMessage
} from '../../../../styles/stylesStyled';

import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from '../../../../App';
import { AnimatedItem } from '../../../../components/animation/AnimatedItem';
import { AnimatedTab } from '../../../../components/animation/AnimatedTab';
import {
  CLUB,
  LP,
  MLP,
  USDT,
  formatUSD,
  showWallet
} from '../../../../helpers/helperFunctions';
import { Button, Flexed } from '../../../../styles/GlobalComponents';
import {
  InvoiceHeader,
  Invoices,
  InvoicesMobile
} from '../../AccountingStyled';
import { SidebarModal } from '../../../../components/common/Sidebar/Sidebar';

import WaitingForPaymentTranfer from './WaitingForPaymentTransfer';

interface TransactionsPageType {
  transfers: any;
  countTransfers: number;
  setCountTransfers: Dispatch<SetStateAction<number>>;
}

export const TransfersPage = ({
  transfers,
  countTransfers,
  setCountTransfers
}: TransactionsPageType) => {
  const { t } = useTranslation('accounting');

  const [isSideModalOpen, setIsSideModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState({
    price: 0,
    currencyType: 1,
    networkType: 1,
    paymentAddress: '',
    type: 1
  });

  const transactionStatus = (status: number) => {
    switch (status) {
      case 1:
        return (
          <span>
            <b
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setIsSideModalOpen(!isSideModalOpen);
              }}>
              Pending
            </b>
          </span>
        );
      case 2:
        return 'Completed';
      case 3:
        return 'Refunded';
      default:
    }
  };

  return (
    <AnimatedTab key={'TransactionsPage'}>
      <Desktop>
        <InvoiceHeader>
          <div style={{ width: '8%' }}>{t('date')}</div>
          <div style={{ width: '10%' }}>{t('transfer_id')}</div>
          <div style={{ width: '12%' }}>{t('paid_amount')}</div>
          <div style={{ width: '12.5%' }}>Received amount</div>
          <div style={{ width: '15.5%' }}>{t('type')}</div>
          <div style={{ width: '32%' }}>{t('wallet')}</div>
          <div style={{ width: '10%' }}>{t('status')}</div>
        </InvoiceHeader>
      </Desktop>

      {transfers?.length === 0 ? (
        <HubLengthMessage>{t('no_withdrawals')}</HubLengthMessage>
      ) : (
        transfers?.map((inv: any, i: number) => {
          return (
            <AnimatedItem index={i} key={i}>
              <Desktop>
                <Invoices>
                  <div style={{ width: '8%' }}>
                    {inv?.datePaid &&
                      moment.utc(inv?.datePaid).format('DD/MM/YY')}
                  </div>
                  <div style={{ width: '10%' }}>#{inv.id}</div>
                  <div style={{ width: '12%' }}>
                    {' '}
                    <span>{formatUSD(inv.price)} </span>
                  </div>
                  <div style={{ width: '12.5%' }}>
                    <span>{formatUSD(inv.receivedAmount)} </span>
                  </div>
                  <div style={{ width: '15.5%' }}>
                    <span>{inv.type}</span>
                  </div>
                  <div style={{ width: '32%' }}>{inv.paymentAddress}</div>

                  <div
                    style={{ width: '10%' }}
                    onClick={() => {
                      const transfer = {
                        price: inv.price,
                        type: inv.type,
                        currencyType: inv.networkCurrencyType,
                        networkType: inv.networkType,
                        paymentAddress: inv.paymentAddress
                      };
                      setSelectedPackage(transfer);
                    }}>
                    {transactionStatus(inv.status)}
                  </div>
                </Invoices>
              </Desktop>
              <Mobile>
                <Mobile>
                  <InvoicesMobile>
                    <FlexBetween>
                      <Flexed column>
                        <div
                          style={{
                            fontWeight: 500,
                            lineHeight: '20px'
                          }}>
                          #{inv.id}
                        </div>
                        <div>
                          {inv?.datePaid &&
                            moment.utc(inv?.datePaid).format('DD/MM/YY')}
                        </div>
                        <div
                          style={{
                            color: '#B5A8A8',
                            lineHeight: '18px',
                            fontSize: 12
                          }}>
                          {transactionStatus(inv.status)}
                        </div>
                      </Flexed>
                      <Flexed column alignEnd>
                        <div
                          style={{
                            fontWeight: 500,
                            fontSize: 18
                          }}>
                          {formatUSD(inv.price)} {USDT}
                        </div>

                        <div
                          style={{
                            fontWeight: 500,
                            fontSize: 18
                          }}>
                          {formatUSD(inv.receivedAmount)} {USDT}
                        </div>
                      </Flexed>
                    </FlexBetween>

                    {inv.paymentAddress && (
                      <Flex>
                        <div>{showWallet(inv.paymentAddress, -30)}</div>
                      </Flex>
                    )}
                  </InvoicesMobile>
                </Mobile>
              </Mobile>
            </AnimatedItem>
          );
        })
      )}
      {transfers?.length >= 50 && transfers?.length === countTransfers && (
        <FlexJustifyCenter>
          <Button
            w='200px'
            mt='10'
            mb='20'
            onClick={() => setCountTransfers((count) => count + 50)}>
            {t('show_more')}
          </Button>
        </FlexJustifyCenter>
      )}

      <SidebarModal
        isOpen={isSideModalOpen}
        setOpen={setIsSideModalOpen}
        title={'Payment instructions'}
        sidebarWidth={'511px'}>
        <WaitingForPaymentTranfer selectedPackage={selectedPackage} />
      </SidebarModal>
    </AnimatedTab>
  );
};
